import { render, staticRenderFns } from "./AddStockLocationPage.vue?vue&type=template&id=1f6a944e"
import script from "./AddStockLocationPage.vue?vue&type=script&lang=js"
export * from "./AddStockLocationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports